<template>
  <div class="firmwareModeSetting">
    <setting-header />
    <v-divider class="firmwareModeSetting_divider" />
    <section class="firmwareModeSetting_content">
      <article class="firmwareModeSetting_item">
        <app-check2
          no-border
          :value="selectedMode === 'AUTO'"
          is-group
          :class="{
            'firmwareModeSetting_item--selected': selectedMode === 'AUTO',
          }"
          @input="handleCheck($event, 'AUTO')"
        >
          自動</app-check2
        >
      </article>
      <article class="firmwareModeSetting_item">
        <app-check2
          no-border
          :value="selectedMode === 'ON'"
          is-group
          :class="{
            'firmwareModeSetting_item--selected': selectedMode === 'ON',
          }"
          @input="handleCheck($event, 'ON')"
        >
          常時有効</app-check2
        >
      </article>
      <article class="firmwareModeSetting_item">
        <app-check2
          no-border
          :value="selectedMode === 'OFF'"
          is-group
          :class="{
            'firmwareModeSetting_item--selected': selectedMode === 'OFF',
          }"
          @input="handleCheck($event, 'OFF')"
        >
          常時無効</app-check2
        >
      </article>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SettingHeader from '../SettingHeader.vue';

export default {
  name: 'FirmwareModeSetting',
  components: {
    SettingHeader,
  },
  data() {
    return {
      submitLoading: false,
      selectedMode: 'AUTO',
      currentMode: 'AUTO',
    };
  },
  computed: {
    ...mapState({
      cameraList: (state) => state.common.cameraList,
      camRecordInfo: (state) => state.settings.camRecordInfo,
    }),
    id() {
      return this.$route.params.id;
    },
    recordSetting() {
      return this.camRecordInfo[String(this.id)];
    },
    daynight() {
      return this.recordSetting?.daynight;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('common', ['setIsLoading']),
    ...mapActions('settings', [
      'setCurrentCamRecordMode',
      'updateRecordSettings',
    ]),
    handleSubmit() {},
    async init() {
      if (this.daynight) {
        let selectedMode = String(this.daynight);
        this.selectedMode = selectedMode;
        this.currentMode = selectedMode;
      } else {
        this.routerPush({
          name: 'settings-firmware-details',
          params: this.$route.params,
        });
      }
    },
    async handleCheck(checked, item) {
      try {
        this.setIsLoading(true);
        await this.updateRecordSettings({
          data: { daynight: item },
          cameraId: this.id,
        });
      } catch (error) {
        console.error();
      } finally {
        this.setIsLoading(false);
      }
      this.selectedMode = item;
    },
  },
};
</script>

<style lang="scss">
.firmwareModeSetting {
  overflow: auto;
  height: 100%;

  &_desc {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    margin-top: 5px;
  }

  &_phone {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
    padding-left: 30px;
  }

  &_item {
    padding: 15px 0;
    user-select: none;
    border-bottom: solid 1px #eeeeee;
    &:last-child {
      border-bottom: solid 1px #cccccccc;
    }
    &--selected {
      .customCheck2_label {
        color: #0075c2;
      }
    }
  }
  &_divider {
    margin-top: 16px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_gap-header {
    height: 26px;
  }
  &_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #ccc;
    &-delete {
      padding: 9px 0;
    }
    padding: 15px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-submit {
      &.theme--light.v-btn.v-btn--has-bg {
        height: 36px;
        border-radius: 5px;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #0075c2;
      }
      &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
        background-color: #f3f3f3 !important;
        box-shadow: none;
        color: #ccc !important;
      }
    }

    &-delete {
      .icon-trash {
        font-size: 16px;
        color: #989898;
      }
    }
  }
}
</style>
